/**
 * Description context.
 */
import Event from '@shared/classes/event';
import useMetadata from '@shared/components/utils/hooks/useMetadata';
import { createContext } from 'react';

/**
 * Description context props.
 */
export interface DescriptionContextProps {
  asset: Event | null;
  display: boolean;
  metadata: ReturnType<typeof useMetadata> | null;
  alternateTip?: boolean;
}

/**
 * Description context creation.
 */
const DescriptionContext = createContext<DescriptionContextProps>({
  asset: null,
  display: false,
  metadata: null,
  alternateTip: false,
});

export default DescriptionContext;
